export const RoadmapList = [
  {
    id: 1,
    month: "2019.10",
    task: ["PoC-0 : Launch Plasm Network minimum testnet(Miniplasm)"]
  },
  {
    id: 2,
    month: "2019.12",
    task: [
      "PoC-1: Start the Testnet Lockdrop.",
      "PoC-2: Implement Operator trading modules.",
      "PoC-3: Implement  Dapps Rewards modules.",
      "Launch Plasm Network Testnet v3.0"
    ]
  },
  {
    id: 3,
    month: "2020.02",
    task: ["PoC-4: Start the Mainnet Lcodrop."]
  },
  {
    id: 4,
    month: "2020.03",
    task: ["Launch Plasm Network Mainnet"]
  },
  {
    id: 5,
    month: "2020.04",
    task: ["PoC-5: Implement OVM Modules."]
  },
  {
    id: 6,
    month: "2020.05",
    task: ["PoC-6: Start the second ETH & BTC Lockdrop."]
  },
  {
    id: 7,
    month: "2020.07",
    task: ["PoC-7: Start the third ETH & BTC & DOT Lockdrop."]
  },
  {
    id: 8,
    month: "2020.08",
    task: ["PoC-8: Plasm Network becomes a parachain. (Depends on Polkadot)"]
  },
  {
    id: 9,
    month: "2020.09",
    task: ["PoC-9: Plasm Network migrate to NPoS."]
  },
  {
    id: 10,
    month: "2021",
    task: ["Listing!!"]
  }
];
